module.exports = __webpack_public_path__ + "img/Bitmap-Copy-6.b29a605c.png";